import { render } from "./4.GetInTouch.vue?vue&type=template&id=b5c12c9c&scoped=true"
import script from "./4.GetInTouch.vue?vue&type=script&lang=js"
export * from "./4.GetInTouch.vue?vue&type=script&lang=js"

import "./4.GetInTouch.vue?vue&type=style&index=0&id=b5c12c9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c12c9c"]])

export default __exports__